export default [{"url":"https://testhq-0.api.invexerp.io","name":"Hq","port":"6508","isStore":true,"isHQ":true}]